import styled from 'styled-components';

import { ActionsContainer, DropdownsContainer, SnackbarWrapper } from '../baseDealFooter/Footer.style.interstate';
import { CompactHeaderActionsWrapper } from '../compactUIHeader/CompactUIHeaderActions.style';
import { ScreenWidth, mediaDown } from '../utils/breakPointUtils';
import {
    HeaderActionsContainer,
    HeaderActionsSeparator,
    HeaderBuyerContainer,
    HeaderDealContainer,
    HeaderDetailsAndAssistantRow,
    HeaderEnhancedShopperDetails,
    HeaderModeSwitchArea,
    HeaderRowContainer,
    HeaderShopperNameAndActions,
    ShopperDetailItem
} from './Header.style.interstate';

const GUTTER = '16px';
const ITEM_GAP = '0.6rem';
const SEPARATOR_MAX_WIDTH = '2px';

export const MODE_SWITCH_WIDTH_VAR = '--mv-mode-switch-width';

export const MvHeaderRowContainer = styled(HeaderRowContainer)`
    padding: 0;
`;

export const MvHeaderScroller = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
    scroll-padding-inline: ${GUTTER};
`;

export const HeaderActionItem = styled.span`
    display: flex;
    align-items: stretch;
    gap: ${ITEM_GAP};
    margin-left: calc(-1 * (${ITEM_GAP} + ${SEPARATOR_MAX_WIDTH}));
    white-space: nowrap;
`;

export const MvHeaderLayout = styled.div`
    box-sizing: border-box;
    min-width: ${ScreenWidth.PHABLET}px;
    padding: 0.6rem ${GUTTER} 0;

    && {
        ${HeaderBuyerContainer} {
            display: grid;
            grid-template-columns: minmax(min-content, 1fr) auto;
            grid-template-areas:
                'main switch'
                'details details';
            gap: 0.6rem 1rem;
        }

        ${HeaderDealContainer} {
            display: contents;
        }

        ${HeaderShopperNameAndActions} {
            grid-area: main;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            column-gap: calc(2 * ${ITEM_GAP} + ${SEPARATOR_MAX_WIDTH});
            row-gap: 0.4rem;
            clip-path: inset(-1rem -1rem -1rem -4px);
        }

        ${HeaderActionsContainer} {
            display: contents;
        }

        ${HeaderActionsSeparator} {
            display: block;
        }

        ${HeaderModeSwitchArea} {
            ${MODE_SWITCH_WIDTH_VAR}: 180px;
            grid-area: switch;
            justify-self: end;
            align-self: start;

            &:empty {
                display: none;
            }
        }

        ${HeaderDetailsAndAssistantRow} {
            grid-area: details;
        }

        ${HeaderEnhancedShopperDetails} {
            grid-area: details;
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem 2.5rem;
        }

        ${ShopperDetailItem}:not(:last-child)::after {
            display: block;
        }

        ${CompactHeaderActionsWrapper} {
            overflow: visible;
            justify-content: space-between;
            gap: 0.5rem 1rem;

            .deal-dates-and-status-container {
                flex: 1 1 auto;
            }

            .deal-dates-and-status-container .dashboard-container {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                row-gap: 0.5rem;
                text-align: left;
            }

            .actions-container {
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-start;
                gap: ${ITEM_GAP};

                .ids-status-indicator-root {
                    margin-right: 0;
                }
            }

            .actions-container:first-child {
                margin-left: auto;
            }
        }

        ${ActionsContainer} ${DropdownsContainer} {
            justify-content: flex-start;
            gap: ${ITEM_GAP};

            & > * {
                flex: none;
            }
        }

        ${ActionsContainer} ${SnackbarWrapper} {
            display: contents;
        }

        @media ${mediaDown(ScreenWidth.TABLET)} {
            ${HeaderBuyerContainer} {
                grid-template-columns: minmax(min-content, 1fr);
                grid-template-areas:
                    'main'
                    'details'
                    'switch';
            }

            ${HeaderModeSwitchArea} {
                ${MODE_SWITCH_WIDTH_VAR}: 100%;
                justify-self: stretch;
            }
        }
    }
`;
